export const REFERRAL_ENVELOPE_IMAGE = 'assets/images/referral-envelope.webp';
export const REFERRAL_SHARE_EMAIL_ICON = 'assets/icons/referral_share_envelope.svg';
export const REFERRAL_SHARE_MESSAGES_ICON = 'assets/icons/referral_share_message.svg';
export const REFERRAL_SHARE_WHATSAPP_ICON = 'assets/icons/referral_share_whatsapp.svg';
export const REFERRAL_MESSENGER_ICON = 'assets/icons/referral-messenger.svg';
export const REFERRAL_DETAIL_CHECKMARK_ICON = 'assets/icons/referral_detail_checkmark.svg';
export const REFERRAL_DETAIL_CLOCK_ICON = 'assets/icons/referral_detail_clock.svg';
export const REFERRAL_DETAIL_FAILED_ICON = 'assets/icons/referral_detail_xmark.svg';
